<template>
  <form class="form-group" @submit.prevent="handleSubmit" ref="formRef">
      <label>Prénom *</label>
      <input
        v-model="localData.firstName"
        type="text"
        placeholder="Ex: Jean"
      />
      <label>Nom *</label>
      <input
        v-model="localData.lastName"
        type="text"
        placeholder="Ex: Dupont"
      />
      <label>Email *</label>
      <input
        v-model="localData.email"
        type="email"
        placeholder="Ex: jean.dupont@example.com"
      />
    <div class="group-rows">
      <div class="group-columns flex-mini">
        <label>Pays</label>
          <select v-model="localData.country" id="country" required>
            <option value="">Sélectionner un pays</option>
            <option v-for="country in countries" :key="country.id" :value="country.id">
              {{ country.name }}
            </option>
        </select>
      </div>
      <div class="group-columns">
      <label>Téléphone</label>
      <input
        v-model="localData.phone"
        type="tel"
        placeholder="Ex: 0612345678"
        required="true"
      />
      </div>
    </div>
      <label>{{ isEdit ? 'Nouveau mot de passe (laisser vide pour ne pas changer)' : 'Mot de passe *' }}</label>
      <input
        v-model="localData.password"
        type="password"
        :placeholder="isEdit ? 'Laisser vide si inchangé' : 'Mot de passe'"
        :required="false"
      />
    <div class="group-rows">
      <div class="group-columns flex-auto">
      <label>Rôles *</label>
      <div class="checkbox-group">
        <label class="checkbox-label">
          <input
            type="checkbox"
            :checked="localData.roles.includes('ROLE_USER')"
            @change="toggleRole('ROLE_USER')"
            class="checkbox-input"
          />
          <span class="checkbox-text">Utilisateur</span>
        </label>
        <label class="checkbox-label">
          <input
            type="checkbox"
            :checked="localData.roles.includes('ROLE_DRIVER')"
            @change="toggleRole('ROLE_DRIVER')"
            class="checkbox-input"
          />
          <span class="checkbox-text">Chauffeur</span>
        </label>
        <label class="checkbox-label">
          <input
            type="checkbox"
            :checked="localData.roles.includes('ROLE_SELLER')"
            @change="toggleRole('ROLE_SELLER')"
            class="checkbox-input"
          />
          <span class="checkbox-text">Vendeur</span>
        </label>
        <label class="checkbox-label">
          <input
            type="checkbox"
            :checked="localData.roles.includes('ROLE_ADMIN')"
            @change="toggleRole('ROLE_ADMIN')"
            class="checkbox-input"
          />
          <span class="checkbox-text">Administrateur</span>
        </label>
      </div>
      </div>
      <div class="group-columns flex-auto">
        <label>Autres</label>
      <label class="checkbox-label checkbox-label-block">
        <input
          type="checkbox"
          v-model="localData.isVerified"
          class="checkbox-input"
        />
        <span class="checkbox-text">Compte vérifié</span>
      </label>
        <!--<p class="help-text">Un compte vérifié peut se connecter immédiatement</p>-->
    </div>
      </div>

    <div v-if="error" class="error-message">{{ error }}</div>

  </form>
</template>

<script setup>
import { ref, watch } from 'vue'

const props = defineProps({
  formData: { type: Object, default: () => ({ firstName: '', lastName: '', email: '', country: '', phone: '', password: '', roles: ['ROLE_USER'], isVerified: false }) },
  countries: { type: Array, default: () => [] },
  isEdit: { type: Boolean, default: false }
})

const emit = defineEmits(['submit', 'cancel'])

const formRef = ref(null)
const error = ref('')

const localData = ref({
  firstName: props.formData?.firstName || '',
  lastName: props.formData?.lastName || '',
  email: props.formData?.email || '',
  country: props.formData?.country || '',
  phone: props.formData?.phone || '',
  password: props.formData?.password || '',
  roles: props.formData?.roles || ['ROLE_USER'],
  isVerified: props.formData?.isVerified || false
})

watch(() => props.formData, (newFormData) => {
  if (newFormData) {
    localData.value = {
      firstName: newFormData.firstName || '',
      lastName: newFormData.lastName || '',
      email: newFormData.email || '',
      phone: newFormData.phone || '',
      password: newFormData.password || '',
      roles: newFormData.roles || ['ROLE_USER'],
      country: newFormData.country || '',
      isVerified: newFormData.isVerified || false
    }
  }
}, { deep: true })

const toggleRole = (role) => {
  const currentRoles = [...localData.value.roles]
  const index = currentRoles.indexOf(role)

  if (index > -1) {
    currentRoles.splice(index, 1)
  } else {
    currentRoles.push(role)
  }

  localData.value.roles = currentRoles
}

const handleSubmit = () => {
  error.value = ''

  if (!formRef.value?.checkValidity()) {
    formRef.value?.reportValidity()
    return
  }

  if (localData.value.roles.length === 0) {
    error.value = 'Sélectionnez au moins un rôle'
    return
  }

  emit('submit', { ...localData.value })
}

defineExpose({ handleSubmit })
</script>
